export const updateHistoryState = (
  url: string,
  options: { type?: 'replace' | 'push' } = {},
) => {
  if (typeof window === 'undefined' || !window.history) return

  const { type = 'replace' } = options

  if (type === 'push') {
    window.history.pushState(null, '', url.toString())
  } else {
    window.history.replaceState(null, '', url.toString())
  }
}
